import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

type BoostedBadgeProps = React.HTMLAttributes<HTMLSpanElement>;

export const BoostedBadge = ({ className, ...rest }: BoostedBadgeProps) => {
  const { t } = useTranslation();

  return (
    <span {...rest} className={classNames('boosted-badge', className)} data-testid="boosted-badge">
      {t('common.item-boosted')}
    </span>
  );
};
